<div class="container">
  <div class="row head mt-2">
    <div class="col-12">
      <span class="title" i18n="preselection|@@picturePreselection">Présélection photos</span>
    </div>
  </div>
  <div class="row key-value">
    <div class="col-12 col-lg-3" i18n="parameters-style|@@photo_three_four">
      Photos 3/4
    </div>
    <div class="col-12 col-lg-9" *ngIf="tchek && tchek.picturesSelectedUrl">
      <div class="row duo">
        <div *ngFor="let image of tchek.picturesSelectedUrl" class="col-12 col-lg-6 mb-2 d-none" #parent>
          <img class="imgVehicle" [src]="image" alt="Image du véhicule" (load)="parent.classList.remove('d-none')">
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/preselection/preselection.component.html